/**
* Copyright Zendesk, Inc.
*
* Use of this source code is governed under the Apache License, Version 2.0
* found at http://www.apache.org/licenses/LICENSE-2.0.
*/
import styled from 'styled-components';
import { DEFAULT_THEME } from '@zendeskgarden/react-theming';
import { StyledBreadcrumbItem } from './StyledBreadcrumbItem.js';

const StyledCenteredBreadcrumbItem = styled(StyledBreadcrumbItem).attrs({
  'aria-hidden': true
}).withConfig({
  displayName: "StyledCenteredBreadcrumbItem",
  componentId: "sc-1ces9y2-0"
})(["display:flex;align-items:center;"]);
StyledCenteredBreadcrumbItem.defaultProps = {
  theme: DEFAULT_THEME
};

export { StyledCenteredBreadcrumbItem };
